import { getHublessRootUrl } from './urls';
export default function isHubless() {
  // eslint-disable-next-line no-restricted-syntax
  return window.location.href.includes(getHublessRootUrl());
}